<div class="container">
  <div class="title">
    {{data.servico.pstcNmServTec}}
  </div>
  <div class="documents-container">
    <div class="documents">Documentos Essenciais</div>
    <mat-list role="list">
      <mat-list-item *ngFor="let doc of data.docsObrigatorios" style="margin-bottom: 23px;">
        <span class="document-description-container"> 
          <mat-icon class="document-title"
            mat-list-icon>draft
          </mat-icon>
        </span>
        <span class="document-description"> {{doc.dostNmDocumento }}</span>
      </mat-list-item>
    </mat-list>
  </div>
  <div style="clear: both;"></div>
  <div *ngIf="data.docsDesejaveis.length > 0" class="documents-container">
    <div class="documents">Documentos Desejáveis</div>
    <mat-list role="list">
      <mat-list-item *ngFor="let doc of data.docsDesejaveis" style="margin-bottom: 23px;">
        <span class="document-description-container"> 
          <mat-icon class="document-title" 
            mat-list-icon>draft
          </mat-icon>
        </span>
        <span class="document-description">{{ doc.dostNmDocumento }}</span>
      </mat-list-item>
    </mat-list>
  </div>

  <div align="end">
    <button mat-button mat-flat-button color="accent" (click)="onNoClick()">Fechar</button>
  </div>
</div>
